import React, { Component } from 'react';
import { Row, Col } from "react-bootstrap";
import { CustomCard } from "../../../components/Card/CustomCard";

import { PubMercSemI, PubMercSemII, PubMercSemIII, PubMercSemIV, PubMercSemV, PubMercSemVI, PubMercElec } from "../../../shared/PensumItems";

class Pensum extends Component {

    materias = (mate) => {
        return (
            mate.map(option => (
                <li key={option.id} className="fuente-monserrat" style={{padding:5}}> 
                    <i class="fa fa-circle" style={{color:"#1f2f6e", fontSize:8}}/> {option.nombre}
                </li>
            ))  
        )
    }

    render() { 
        return (
            <div style = {{backgroundColor:"fafafa"}}>
                <Row>
                    <Col md={12} align="center">
                        <h2 className="fuente-monserrat" style={{color:"#619C9B"}}>PLAN DE ESTUDIO</h2>
                    </Col>
                </Row>
                <Row className="padding-card">
                    <Col md={4}>
                        <CustomCard
                            height = {340}
                            title={<div className="fuente-monserrat">I SEMESTRE</div>}
                            color="#a80012"
                            content={<ul>{this.materias(PubMercSemI)}</ul>}
                        />
                    </Col>
                    <Col md={4}>
                        <CustomCard
                            height = {340}
                            title={<div className="fuente-monserrat">II SEMESTRE</div>}
                            color="#a80012"
                            content={<ul>{this.materias(PubMercSemII)}</ul>}
                        />
                    </Col>
                    <Col md={4}>
                        <CustomCard
                            height = {340}
                            title={<div className="fuente-monserrat">III SEMESTRE</div>}
                            color="#a80012"
                            content={<ul>{this.materias(PubMercSemIII)}</ul>}
                        />
                    </Col>
                    <Col md={4}>
                        <CustomCard
                            height = {340}
                            title={<div className="fuente-monserrat">IV SEMESTRE</div>}
                            color="#a80012"
                            content={<ul>{this.materias(PubMercSemIV)}</ul>}
                        />
                    </Col>
                    <Col md={4}>
                        <CustomCard
                            height = {340}
                            title={<div className="fuente-monserrat">V SEMESTRE</div>}
                            color="#a80012"
                            content={<ul>{this.materias(PubMercSemV)}</ul>}
                        />
                    </Col>
                    <Col md={4}>
                        <CustomCard
                            height = {340}
                            title={<div className="fuente-monserrat">VI SEMESTRE</div>}
                            color="#a80012"
                            content={<ul>{this.materias(PubMercSemVI)}</ul>}
                        />
                    </Col>
                    <Col md={4}></Col>
                    <Col md={4}>
                        <CustomCard
                            height = {340}
                            title={<div className="fuente-monserrat">ELECTIVAS</div>}
                            color="#a80012"
                            content={<ul>{this.materias(PubMercElec)}</ul>}
                        />
                    </Col>
                    <Col md={4}></Col>
                </Row>
            </div>
        );
    }
}
 
export default Pensum;


// WEBPACK FOOTER //
// ./src/site/Componentes/PublicidadMercadeo/Pensum.jsx